import React, { useState } from 'react'
import { ImArrowRight } from 'react-icons/im'
import { ImArrowLeft } from 'react-icons/im'
import { ImCross } from 'react-icons/im'
import { MdCopyAll } from 'react-icons/md'
import styles from './ModalPaymentHistory.module.css'
import CopyToClipboard from 'react-copy-to-clipboard'
import { toast } from 'react-toastify'

import Loader from '../../loader/Loader'
import { 
  useGetClientPaymentHistoryQuery,
  useGetClientPaymentSourceQuery 
} from '../../../redux/clientData/apiClientData'

const ModalPaymentHistory = ({ setIsShowPaymentHistory }) => {
  const { data: clientPaymentHistory, isLoading: isLoadingPaymentHistory } =
    useGetClientPaymentHistoryQuery()
  
  const { data: paymentSourceData, isLoading: isLoadingPaymentSource } =
    useGetClientPaymentSourceQuery()

  const paymentHistory = clientPaymentHistory?.paymentHistory.filter(
    (payment) => payment.amount
  )

  const [currentPage, setCurrentPage] = useState(1)

  const itemsPerPage = 10

  const totalItems = paymentHistory?.length
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const lastItemIndex = currentPage * itemsPerPage
  const firstItemIndex = lastItemIndex - itemsPerPage
  const currentItems = paymentHistory?.slice(firstItemIndex, lastItemIndex)

  const goToNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages))
  }

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
  }

  const onCopy = (text, result) => {
    if (result) {
      toast.success('Скопійовано')
    } else {
      toast.error('Не вдалося скопіювати')
    }
  }

  if (isLoadingPaymentHistory || isLoadingPaymentSource) return <Loader />

  return (
    <div
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setIsShowPaymentHistory(false)
        }
      }}
      className="overlayCont"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={styles.modalContainer}
      >
        <div className={styles.modalHeader}>
          <div>Оплати</div>
          <div
            onClick={() => setIsShowPaymentHistory(false)}
            className={styles.closeIcon}
          >
            <ImCross />
          </div>
        </div>
        {paymentSourceData && (
          <div className={styles.paymentInfoContainer}>
            <h4 className={styles.paymentInfoTitle}>Інформація для оплати:</h4>
            <div className={styles.paymentInfoContent}>
              <div className={styles.paymentInfoItem}>
                <span className={styles.paymentInfoLabel}>Отримувач:</span>
                <span className={styles.paymentInfoValue}>{paymentSourceData.accName}</span>
              </div>
              <div className={styles.paymentInfoItem}>
                <span className={styles.paymentInfoLabel}>ЄДРПОУ:</span>
                <div className={styles.paymentInfoValueContainer}>
                  <span className={styles.paymentInfoValue}>{paymentSourceData.ipnn}</span>
                  <CopyToClipboard text={paymentSourceData.ipnn} onCopy={onCopy}>
                    <span
                      onClick={(e) => e.stopPropagation()}
                      className={styles.copyIconSpan}
                    >
                      <MdCopyAll />
                    </span>
                  </CopyToClipboard>
                </div>
              </div>
              <div className={styles.paymentInfoItem}>
                <span className={styles.paymentInfoLabel}>IBAN:</span>
                <div className={styles.paymentInfoValueContainer}>
                  <span className={styles.paymentInfoValue}>{paymentSourceData.iban}</span>
                  <CopyToClipboard text={paymentSourceData.iban} onCopy={onCopy}>
                    <span
                      onClick={(e) => e.stopPropagation()}
                      className={styles.copyIconSpan}
                    >
                      <MdCopyAll />
                    </span>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
        )}
        {paymentHistory && paymentHistory.length === 0 ? (
          <div className={styles.noPaymentHistory}>
            <p>Історія оплат відсутня...</p>
          </div>
        ) : (
          <>
            <table className={styles.historyPaymentTable}>
              <thead>
                <tr>
                  <th>Сума</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && currentItems.map((payment, i) => (
                  <tr key={i}>
                    <td>{payment.amount}</td>
                    <td>{payment.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <hr className={styles.modalHR} />
            <div className={styles.infoBtnContainer}>
              <button
                disabled={currentPage === 1}
                onClick={goToPreviousPage}
                className={styles.arrowBtn}
              >
                <ImArrowLeft />
              </button>
              {currentPage} з {totalPages}
              <button
                disabled={currentPage === totalPages}
                onClick={goToNextPage}
                className={styles.arrowBtn}
              >
                <ImArrowRight />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default ModalPaymentHistory
